// Small shared helper: keep track of the last 5 site fichas opened by the user.
// Stored in localStorage['sf_recent_sites'] — used by GlobalSearch quick-access panel.
const KEY = 'sf_recent_sites';
const MAX = 5;

export const getRecentSites = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(raw) ? raw.slice(0, MAX) : [];
  } catch { return []; }
};

export const pushRecentSite = (site) => {
  if (!site || !site.code) return;
  try {
    const prev = getRecentSites();
    const entry = {
      code: site.code,
      title: site.title || site.name || site.code,
      subtitle: site.subtitle || site.municipality || '',
      lat: site.lat, lng: site.lng,
      at: Date.now(),
    };
    const dedup = [entry, ...prev.filter((x) => x.code !== entry.code)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(dedup));
    // Broadcast so any open GlobalSearch instance refreshes immediately.
    window.dispatchEvent(new CustomEvent('sf:recent-sites-changed'));
  } catch { /* ignore */ }
};

export const clearRecentSites = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent('sf:recent-sites-changed'));
};
